"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MongoPointLocation = void 0;
require("reflect-metadata");
/**
 * Mongo native format, must be also indexed as 2dsphere to work
 */
class MongoPointLocation {
    constructor(position) {
        this.type = "Point";
        this.type = "Point";
        if (position && !isNaN(position.longitude) && !isNaN(position.latitude)) {
            this.coordinates = [position.longitude, position.latitude];
        }
    }
}
exports.MongoPointLocation = MongoPointLocation;
//# sourceMappingURL=MongoPointLocation.js.map